var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c(_vm.selectedComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }